import { ContributorType } from '@risksmart-app/domain/src/types/consts';

/** The keys double as i18n keys under `scheduler.assignment_options`. */
export const ASSIGNMENT_RULES = [
  'owner',
  'contributor',
  'owner_and_contributor',
] as const;

export type AssignmentRule = (typeof ASSIGNMENT_RULES)[number];

/**
 * `viewer` and `any` are absent structurally rather than validated away: a
 * read-only association is not somebody who can do the work, and `any` is a
 * `role_access` wildcard.
 */
export type AssigneeContributorType =
  | ContributorType.Contributor
  | ContributorType.Owner;

/**
 * "Object owners" on a control beneath a risk does not include the risk's own
 * owner. `ancestor_contributor_view` recodes an inherited owner of a
 * differently-typed ancestor down to `contributor`, so that person arrives
 * under "Object contributors" instead — the same as the control's Owners panel
 * on its object page.
 */
export const toAssigneeContributorTypes = (
  rule: AssignmentRule
): AssigneeContributorType[] => {
  switch (rule) {
    case 'owner':
      return [ContributorType.Owner];
    case 'contributor':
      return [ContributorType.Contributor];
    case 'owner_and_contributor':
      return [ContributorType.Owner, ContributorType.Contributor];
  }
};
